<template>
  <v-dialog v-model="dialog" max-width="1050px" scrollable>
    <div class="modal-container" color="#333333" dark>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <ProjectHeroMediaUpload
              :cover-file="selectedFile"
              :banner-file="selectedBannerFile"
              :title="localObra.nome"
              :description="localObra.descricao"
              :metadata="previewMetadata"
              :age-rating="previewAgeRating"
              page-sizing
              @cover-selected="selectedFile = $event"
              @banner-selected="selectedBannerFile = $event"
              @error="showSnackbar($event, 'error')"
            />
          </v-col>
          <v-col cols="12" class="fields-col">
            <v-text-field label="Nome" v-model="localObra.nome" placeholder="Ex: O Nome do Vento"
              :rules="[v => !!v || 'O nome da obra é obrigatório']" outlined dense class="custom-input">
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                  </template>
                  <span>Insira o nome da obra, como o título do livro ou projeto.</span>
                </v-tooltip>
              </template>
            </v-text-field>

            <v-row>
              <v-col cols="12" sm="6">
                <v-select label="Categoria" v-model="localObra.categoria" :items="categorias" item-text="name"
                  item-value="id" :rules="[v => !!v || 'A categoria é obrigatória']" placeholder="Ex: Literatura"
                  outlined dense class="custom-input">
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Selecione a categoria principal da obra, como Literatura, Arte, etc.</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select label="Gênero" v-model="localObra.genero" :items="generos" item-text="name" item-value="id"
                  :rules="[v => !!v || 'O gênero é obrigatório']" placeholder="Ex: Romance" outlined dense
                  class="custom-input">
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Escolha o gênero, como Romance, Ficção Científica, etc.</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-select label="Idioma" v-model="localObra.idioma" :items="idiomas" item-text="name" item-value="id"
                  :rules="[v => !!v || 'O idioma é obrigatório']" placeholder="Ex: Português" outlined dense
                  class="custom-input">
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Selecione o idioma principal da obra.</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select label="Tipo da Obra" v-model="localObra.tipo" :items="tiposObra" item-text="name"
                  item-value="id" :rules="[v => !!v || 'O tipo da obra é obrigatório']" placeholder="Ex: Livro" outlined
                  dense class="custom-input">
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Defina o tipo de obra, como One-Shot, Série, etc.</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select label="Tipo de leitura" v-model="localObra.type_reading" :items="type_readings" outlined dense
                  class="custom-input" disabled>
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                      </template>
                      <span>Tipo de leitura da obra (atualmente fixo).</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-textarea label="Descrição" v-model="localObra.descricao"
              placeholder="Ex: Uma história épica sobre um jovem herói..." outlined dense class="custom-input mt-3">
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                  </template>
                  <span>Descreva brevemente o conteúdo ou objetivo da obra.</span>
                </v-tooltip>
              </template>
            </v-textarea>

            <AgeRatingPickerInline
              v-model="localObra.age_rating_ids"
              :ageRatings="ageRatings"
              class="mt-2"
            />

          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>

        <v-btn fab small color="primary" class="help-button" @click="showHelp" aria-label="Abrir guia de ajuda">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>


        <v-spacer></v-spacer>
        <v-btn color="red" @click="closeModal">Cancelar</v-btn>
        <v-btn class="zinnes-primary-btn" @click="saveObra" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </div>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
      {{ snackbar.message }}
    </v-snackbar>

    <v-dialog v-model="helpDialog" max-width="500px">
      <v-card>
        <v-card-title>Como preencher o formulário</v-card-title>
        <v-card-text>
          <p><strong>Nome:</strong> Insira o título da sua obra.</p>
          <p><strong>Categoria:</strong> Escolha a categoria principal, como Literatura.</p>
          <p><strong>Gênero:</strong> Selecione o gênero, como Romance ou Fantasia.</p>
          <p><strong>Idioma:</strong> Escolha o idioma da obra.</p>
          <p><strong>Tipo da Obra:</strong> Defina o tipo, como Livro ou Artigo.</p>
          <p><strong>Descrição:</strong> Adicione uma breve descrição da obra.</p>
          <p><strong>Capa da obra:</strong> imagem vertical A5 usada em cards e na capa sobreposta.</p>
          <p><strong>Banner da pagina da obra:</strong> imagem para o topo publico em 1600x920px.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="helpDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import UtilMixins from '@/mixins/UtilMixins.js';
import { getAllProjects, saveWork, getGenders, getProjectType, getLanguages, getCategorys, getAgeRatings } from '../server/workService.js'
import AgeRatingPickerInline from '@/components/AgeRatingPickerInline.vue';
import ProjectHeroMediaUpload from '@/components/ProjectHeroMediaUpload.vue';
import { getHighestAgeRating, normalizeAgeRatingIds } from '@/utils/ageRatings';

export default {
  name: "AddNewWorkModal",
  mixins: [UtilMixins],
  components: { AgeRatingPickerInline, ProjectHeroMediaUpload },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    obras: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      snackbar: {
        show: false,
        message: '',
        color: '',
        timeout: 2500,
      },
      dialog: this.value,
      localObra: {
        nome: '',
        categoria: '',
        genero: '',
        idioma: '',
        tipo: '',
        descricao: '',
        type_reading: 1,
        age_rating_ids: [],
      },
      idiomas: [],
      tiposObra: [],
      categorias: [],
      generos: [],
      ageRatings: [],
      type_readings: [
        { value: 1, text: 'Ocidental' },
        { value: 2, text: 'Oriental' },
      ],
      selectedFile: null,
      selectedBannerFile: null,
      newObras: [],
      helpDialog: false,
      loading: false,
    };
  },

  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newValue) {
      this.$emit('input', newValue);
    },
    newObras(newValue) {
      this.$emit('updateNewObra', newValue);
    }
  },

  async created() {
    this.categorias = await getCategorys({ id: 1 });
    this.categorias = this.categorias.filter(({ id }) => id == 1);
    this.generos = await getGenders();
    this.idiomas = await getLanguages();
    this.tiposObra = await getProjectType({ project_category_id: 1 });
    const ratings = await getAgeRatings();
    this.ageRatings = ratings?.data || ratings || [];
  },

  computed: {
    previewAgeRating() {
      return getHighestAgeRating(this.ageRatings, this.localObra.age_rating_ids);
    },
    previewMetadata() {
      return [
        this.findName(this.categorias, this.localObra.categoria),
        this.findName(this.tiposObra, this.localObra.tipo),
        this.findName(this.generos, this.localObra.genero),
        this.findName(this.idiomas, this.localObra.idioma),
        this.findText(this.type_readings, this.localObra.type_reading),
      ];
    },
  },

  methods: {
    closeModal() {
      this.dialog = false;
      this.localObra = {
        nome: '',
        categoria: '',
        genero: '',
        idioma: '',
        tipo: '',
        descricao: '',
        type_reading: 1,
        age_rating_ids: [],
      };
      this.selectedFile = null;
      this.selectedBannerFile = null;
    },
    async saveObra() {
      try {
        if (!this.localObra.nome) {
          this.showSnackbar('O campo Nome é obrigatório.', 'error');
          return;
        }
        if (!this.localObra.categoria) {
          this.showSnackbar('Selecione uma Categoria.', 'error');
          return;
        }
        if (!this.localObra.genero) {
          this.showSnackbar('Selecione um Gênero.', 'error');
          return;
        }
        if (!this.localObra.idioma) {
          this.showSnackbar('Selecione um Idioma.', 'error');
          return;
        }
        if (!this.localObra.tipo) {
          this.showSnackbar('Selecione o Tipo da Obra.', 'error');
          return;
        }
        if (!this.selectedFile) {
          this.showSnackbar('Adicione uma imagem para a obra.', 'error');
          return;
        }

        this.loading = true;
        const formData = new FormData();
        formData.append("name", this.localObra.nome);
        formData.append("project_category_id", this.localObra.categoria);
        formData.append("project_type_id", this.localObra.tipo);
        formData.append("gender_id", this.localObra.genero);
        formData.append("language_id", this.localObra.idioma);
        formData.append("description", this.localObra.descricao);
        formData.append("project_thumb", this.selectedFile);
        formData.append("type_reading", this.localObra.type_reading);
        formData.append("age_rating_ids", JSON.stringify(normalizeAgeRatingIds(this.localObra.age_rating_ids)));
        if (this.isFile(this.selectedBannerFile)) {
          formData.append("project_banner", this.selectedBannerFile);
        }

        await saveWork(formData);
        this.newObras = await getAllProjects();
        this.loading = false;
        this.showSnackbar('Obra criada com sucesso!', 'success');
        this.closeModal();
      } catch (error) {
        this.loading = false;
        this.showSnackbar(`Erro ao salvar a obra: ${error.message}`, 'error');
      }
    },
    showSnackbar(message, type) {
      this.snackbar.message = message;
      this.snackbar.color = type === 'success' ? 'green' : 'red';
      this.snackbar.show = true;
    },
    isFile(value) {
      return Object.prototype.toString.call(value) === '[object File]';
    },
    findName(items, id) {
      const item = items.find((entry) => entry.id === id);
      return item ? item.name : '';
    },
    findText(items, value) {
      const item = items.find((entry) => entry.value === value);
      return item ? item.text : '';
    },
    showHelp() {
      this.helpDialog = true;
    }
  }
};
</script>

<style>
.help-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  position: relative;
  padding: 20px;
}

.help-button {
  top: 10px;
  right: 10px;
}

.custom-input {
  margin-bottom: 10px;
}

.modal-container {
  background-color: #dadada !important;
  padding: 16px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.custum-input {
  background-color: #1e1e1e !important;
  color: white !important;
}

.custom-input {
  margin-bottom: 0;
}

.fields-col {
  overflow: visible;
}

@media (max-width: 600px) {
  .modal-container {
    height: auto !important;
    max-height: 90vh;
    overflow-y: auto;
    padding: 8px !important;
    justify-content: flex-start;
  }

  .image-container {
    display: flex;
    justify-content: center;
  }

  .modal-container .row {
    margin-top: -3px !important;
    margin-bottom: -3px !important;
  }

  .modal-container .col {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }

  .modal-container .v-messages {
    min-height: 0 !important;
  }

  .modal-container .v-text-field__details {
    padding-top: 0 !important;
    min-height: 0 !important;
  }
}
</style>
